export const PROBLEMS_TABLE_ITEMS = [
  {
    label: 'Diagnóstico do problema',
    field: 'problemDescription',
    style: { flexGrow: 1, flexBasis: 0, minWidth: '200px' },
  },
  {
    label: 'Solução para o problema',
    field: 'serviceDescription',
    isFlexible: true,
    style: { flexGrow: 1, flexBasis: 0, minWidth: '200px' },
  },
  { label: 'Material', field: 'materialsTotal', style: { width: '100px', flexShrink: 0 } },
  { label: 'Mão de obra', field: 'laborValue', style: { width: '100px', flexShrink: 0 } },
  { label: 'Total', field: 'total', style: { width: '100px', flexShrink: 0 } },
  {
    label: 'Garantia em mês(es)',
    field: 'warrantyMonths',
    style: { width: '120px', flexShrink: 0 },
  },
  { label: 'Tipo', field: 'type', style: { width: '100px' } },
  { label: '', field: 'ai', style: { width: '30px' } },
  { label: '', field: 'expand', style: { width: '30px' } },
  { label: '', field: 'edit', style: { width: '30px' } },
  { label: '', field: 'remove', style: { width: '30px' } },
]

export const MATERIAL_TABLE_ITEMS = [
  {
    label: 'Material',
    field: 'description',
    style: { flexGrow: 1, flexBasis: 0, minWidth: '420px' },
  },
  {
    label: 'Quantidade',
    field: 'quantity',
    style: { width: '100px', flexShrink: 0, marginRight: '10px' },
  },
  { label: 'Valor', field: 'unitPrice', style: { width: '100px', flexShrink: 0 } },
  { label: 'Total', field: 'total', style: { width: '100px', flexShrink: 0 } },
]

export const EDIT_ONLY_PROBLEMS_TABLE_ITEMS = ['edit', 'remove']

export const MATERIAL_TABLE_COLUMNS = [
  {
    key: 'number',
    label: '#',
    type: 'number',
    defaultValue: '',
    placeholder: '',
    style: {
      flex: 0.5,
      maxWidth: '40px',
      minWidth: '40px',
    },
    readOnly: true,
  },
  {
    key: 'description',
    label: 'Material',
    type: 'text',
    defaultValue: '',
    placeholder: 'Material',
    style: {
      flex: 5,
      maxWidth: '100%',
    },
  },
  {
    key: 'quantity',
    label: 'Qt.',
    type: 'currency',
    defaultValue: 0,
    placeholder: '0',
    style: {
      flex: 2,
      maxWidth: '100px',
    },
    prefix: '',
  },
  {
    key: 'unitPrice',
    label: 'Valor',
    type: 'currency',
    defaultValue: '0',
    placeholder: 'R$ 0,00',
    style: {
      flex: 4,
      maxWidth: '150px',
    },
    prefix: 'R$ ',
  },
  {
    key: 'total',
    label: 'Total',
    type: 'currency',
    defaultValue: '0',
    placeholder: 'R$ 0,00',
    style: {
      flex: 4,
      maxWidth: '150px',
    },
    prefix: 'R$ ',
    readOnly: true,
  },
]

export const MATERIAL_TABLE_COLUMNS_WITH_ACTION = [
  ...MATERIAL_TABLE_COLUMNS,
  {
    key: 'remove',
    label: '',
    type: 'remove',
    defaultValue: null,
    style: {},
  },
]

export const budgetFormDefaultValues = budget => ({
  visitHappenedTemp: budget?.visitHappenedTemp ?? null,
  additionalInfo: budget?.additionalInfo ?? '',
  confidentialInfo: budget?.confidentialInfo ?? '',
  executionDue: budget?.executionDue ?? 0,
  additionalWarrantyMonths: budget?.additionalWarrantyMonths ?? null,
})

export const SAAS_BUDGET_TYPES = ['externo', 'interno']

export const MATERIAL_TABLE_DEFAULT_ITEM = Object.fromEntries(
  MATERIAL_TABLE_COLUMNS.map(column => [column.key, null])
)

export const ADD_PROBLEM_FORM_DEFAULT_VALUES = {
  problem: null,
  problemDescription: '',
  serviceDescription: '',
  warrantyMonths: '',
  isServiceMandatory: null,
  materialsTotal: null,
  laborValue: 0,
  numberOfProfessionals: 0,
  laborTimeHours: 0,
  problemMedia: [],
  materials: [MATERIAL_TABLE_DEFAULT_ITEM],
  singleServicePrice: 0,
  compartment: '',
}

export const AI_VALIDATION_MODAL_INITIAL_STATE = {
  open: false,
  handleClick: null,
  title: null,
  label: '',
  message: null,
  handleCancel: null,
}

export const AI_SUGGESTIONS_MODAL_INITIAL_STATE = {
  open: false,
  resolution: {},
  serviceDescription: '',
  problemDescription: '',
  materials: {},
  acceptServiceDescription: null,
  acceptProblemDescription: null,
  acceptMaterials: {},
}
